import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authReducer';
import dropdownReducer from './utils/dropdownReducer';
import settingsReducer from './settings/settingsReducer';
import apiReducer from './api/apiReducer';
import notificationReducer from './notifications/notificationReducer';
import alertReducer from './alert/alertReducer';

import errorReducer from './error/errorReducer'; // added
import acknowledgmentsReducer from './acknowledgments/acknowledgmentsReducer';
import { navigationReducer } from './navigation/navigationReducer';
import realTimeDataReducer from './realTimeData/realTimeDataReducer';
import { onlineUsersReducer } from './onlineUsers/onlineUsersReducer';
import unpaidErrorReducer from './unpaidError/unpaidErrorReducer';
import emergencyAlertReducer from './emergencyAlert/emergencyAlertReducer';




// build reducer map conditionally based on stored role
const role = localStorage.getItem('role');
const isAuthenticated = localStorage.getItem("isAuthenticated") || false

const reducers = {
  auth: authReducer,
  api: apiReducer,
  alerts: alertReducer,
  emergencyAlerts: emergencyAlertReducer,
  settings : settingsReducer,
  utils: dropdownReducer,
  error: errorReducer, // added
  acknowledgments: acknowledgmentsReducer,
  navigation: navigationReducer,
  realTimeData: realTimeDataReducer,
  onlineUsers:onlineUsersReducer,
  unpaidError: unpaidErrorReducer,
  notifications: notificationReducer, // include by default
}





const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['SHOW_ALERT', 'SHOW_EMERGENCY_ALERT'],
        ignoredActionPaths: ['payload.onConfirm', 'payload.onCancel'],
        ignoredPaths: ['alerts.0.onConfirm', 'alerts.0.onCancel', 'emergencyAlerts.alerts'],
      },
    }),
});

export default store;
